<div class="telephone" #telContainer>
  <input
    #telInput
    [readonly]="readonly"
    type="tel"
    class="tel-input t-error-validation relative box-border !h-[44px] w-full overflow-hidden bg-white font-inter text-md font-normal text-gray-700"
    [(ngModel)]="phoneNumber"
    placeholder="{{ 'PAYMENT.PLACEHOLDER.ENTER_PHONE_NUMBER' | translate }}"
    required
    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1');"
    minlength="8"
    maxlength="15"
    (ngModelChange)="handleOnchange($event)"
    (blur)="onTouch()"
  />
</div>
